export const LOGIN = "[USER] LOGIN";
export const LOGIN_SUCCESS = "[USER] LOGIN_SUCCESS";
export const LOGIN_FAILED = "[USER] LOGIN_FAILED";
